import Vue from 'vue'
// import VueViewer from 'v-viewer'
// import screenfull from 'screenfull';
// import VueLazyload from 'vue-lazyload'
import App from './App.vue'
import i18n from './i18n'
import store from './store'
import router from './router'
import Storage from 'vue-ls'
import config from './config'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css';
import moment from 'moment';
import {
  SET_LANGUAGE,
  ACCESS_TOKEN
} from "@/store/mutation-types"
import timeUtils from './utils/timeUtils';

Vue.prototype.$timeUtils = timeUtils;
// import 'viewerjs/dist/viewer.css'
// import flexible from 'lib-flexible/flexible'
// flexible.designWidth = 0

// import  lodingGif from './assets/img/gif/loding.gif'
// import  errorPng from './assets/img/png/error.png'

//插件
// import directiveDeb from './situation/directive'
// import exampleDeb from './situation/example'
// import minxinsDeb from './situation/mixins'
// import componentsDeb from './situation/components'
// import observableDeb from './situation/observable'
// Vue.use(directiveDeb)
// Vue.use(exampleDeb)
// Vue.use(minxinsDeb)
// Vue.use(componentsDeb)
// Vue.use(observableDeb)

// Vue.use(VueViewer)
// Vue.use(VueLazyload, {
//   preLoad: 1.3,
//   error: errorPng,
//   loading: lodingGif,
//   attempt: 2
// })

Vue.use(Antd)
Vue.use(Storage, config.storageConfig)
// Vue.config.productionTip = false
// Vue.prototype.$screenfull = screenfull
// 全局挂载 moment
Vue.prototype.$moment = moment;
new Vue({
  i18n,
  store,
  router,
  mounted(){
    Vue.ls.get(ACCESS_TOKEN) && store.commit('SET_TOKEN', Vue.ls.get(ACCESS_TOKEN))
    Vue.ls.get(SET_LANGUAGE) ? store.commit('SET_Language', Vue.ls.get(SET_LANGUAGE)) : store.commit('SET_Language', 'zh')

  },
  render: h => h(App)
}).$mount('#app')
